import { useSelector } from 'react-redux';

import { Layout, Title } from 'common/components/layout';

import AddRegularCreditCard from './add/AddRegularCreditCard';

const Add = () => {
  const settings = useSelector((state) => state.setting).data;

  if (!settings) {
    return (
      <Layout title="Add New Credit Card" loading>
        <Title>Your Account</Title>
      </Layout>
    );
  }

  return <AddRegularCreditCard />;
};

export default Add;
